module.exports = __webpack_public_path__ + "img/SDG-12-EN.bdd30f3e.png";